import {
  Container,
  Flex,
  Spinner,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { useQuery } from "@tanstack/react-query"
import { EmployeeService, type UserEmployeePublic } from "../../../client"
import useAuth from "../../../hooks/useAuth.ts"
import UserInfoTab from "../../../components/EmployeeUser/BasicInformation/UserInfoTab.tsx";
import CalendarTab from "../../../components/EmployeeUser/OperatingData/CalendarTab.tsx";

export const Route = createFileRoute("/_layout/user/$userId")({
  component: UserDetailsPage,
})

function UserDetailsPage() {
  const { userId } = Route.useParams()
  const { user: currentUser } = useAuth()
  const isSuperAdmin = !!currentUser?.isSuperAdmin
  // const isAdmin = !!currentUser?.isAdmin

  const { data: user, isLoading, error } = useQuery<UserEmployeePublic>({
    queryKey: ["user", userId],
    queryFn: () => EmployeeService.readEmployeeById({ userId }),
  })

  if (isLoading) {
    return (
        <Flex justify="center" align="center" h="50vh">
          <Spinner size="xl" />
        </Flex>
    )
  }

  if (!user || error) {
    return <Text textAlign="center">User not found or an error occurred.</Text>
  }

  return (
      <Container maxW={{ base:"100%", lg:"1100px" }} px={{ base:0, md:4 }} py={8}>

        <Tabs variant="enclosed" colorScheme="blue" mt={6}>
          <TabList>
            <Tab>Basic information</Tab>
            <Tab>Calendar</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <UserInfoTab user={user} isSuperAdmin={isSuperAdmin} />
            </TabPanel>

            <TabPanel>
              <CalendarTab
                  userId={user.ID}
                  userRole={user.isSuperAdmin ? "superadmin" : user.isAdmin ? "admin" : "user"} // роль користувача, над яким проводять дію
                  userFullName={user.fullName || null}
                  userAvatar={user.avatar || null}
              />

            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
  )
}
